module.exports = __webpack_public_path__ + "img/iconNo18.1e5310d0.png";